// extracted by mini-css-extract-plugin
export default {"stickableHeader":"Details_stickableHeader__sHeXV","shadow":"Details_shadow__It6c4","table":"Details_table__vQQeF","placeHolderShimmer":"Details_placeHolderShimmer__VzAF6"};